import { useEffect, useState } from "react";
// import TabContext from "@mui/lab/TabContext";
import { Grid } from "@mui/material";
// import Tab from "@mui/material/Tab";
import SubmittedImg from "../../../assets/images/submittedimg.svg";
// import Tabs from "@mui/lab/TabList";
// import TabPanel from "@mui/lab/TabPanel";
import { toast } from "react-toastify";
import PageTitle from "../../../components/PageTitle";
import Modal from "../../../components/Modal";
import useStyles from "../styles";
// import Button from "../../../components/Button";
import NoExamFound from "../../../assets/images/noexam.svg";
import StudentTestCard from "../components/StudentTestCard";
import { httprequest } from "../../../data/api";
import PageLoader from "../../../components/PageLoader";
import Layout from "../../../components/Layout";

const STUDENT_TEST = "/api/v1/ca-test/student";

const StudentTest = () => {
  const classes = useStyles();
  // const [value, setValue] = useState("");
  const [submittedModal, setSubmittedModal] = useState(false);
  const [noExamModal, setNoExamModal] = useState(false);
  const [exams, setExams] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const handleTabChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  /**
 * Toggles the visibility state of the submitted modal.
 */
  const handleSubmittedModal = () => {
    setSubmittedModal(!submittedModal);
  };

  /**
 * Fetches all exam data for the current student applicant.
 * Sets loading state during the request and handles errors.
 * @async
 */
  const getStudentTest = () => {
    setIsLoading(true);
    httprequest.get(STUDENT_TEST).then((res) => {
      setExams(res?.data?.data);
      setIsLoading(false);
    }).catch((err) => {
      setIsLoading(false);
      toast.error(err.response.data);
    });
  };

  /**
   * Convert UTC date string to local date string
   * @param {*} utcDateString
   * @returns
   */
  // const formatUTCDateToLocal = (utcDateString) => {
  //   if (!utcDateString) return "--/--";

  //   const date = new Date(utcDateString);

  //   // Extract the time part from UTC (hereIignore timezone conversion)
  //   const utcHours = date.getUTCHours();
  //   const utcMinutes = date.getUTCMinutes();

  //   // Convert to 12-hour format
  //   const hours12 = utcHours % 12 || 12;
  //   const ampm = utcHours >= 12 ? "PM" : "AM";
  //   const minutesFormatted = String(utcMinutes).padStart(2, "0");

  //   // Format date part (optional - remove if you only want time)
  //   const day = String(date.getUTCDate()).padStart(2, "0");
  //   const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  //   const year = date.getUTCFullYear();

  //   return `${day}/${month}/${year} ${hours12}:${minutesFormatted} ${ampm}`;
  // };

  /**
 * Effect hook that runs once on component mount to fetch student test data.
 */
  useEffect(() => {
    getStudentTest();
  }, []);

  /**
 * Toggles the visibility state of the no-exam modal.
 */
  const handleNoExamModal = () => {
    setNoExamModal(!noExamModal);
  };

  return (
    <Layout children={
      <div className={`${classes.border} page-content`}>
        <PageTitle
          title="All Test accessible to you"
          subtitle="These are all the test you can take"
          // button={
          //   <div className="flex gap-10">
          //     <Button onClick={handleNoExamModal} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Check for Exam" />
          //   </div>
          // }
        />
        <div className="page-content height-full">
          <Grid container spacing={2}>
            {isLoading ? (
              <div className="padding-top-56 margin-auto">
                <PageLoader />
              </div>
            ) : (
              <>
                {exams && exams.length > 0 ? (
                  exams?.map((test, index) => {
                    const isTestActive = () => {
                      if (!test?.test_date) return false;

                      const testDate = new Date(test?.test_date?.replace("Z", ""));
                      const now = new Date();

                      return now >= testDate;
                    };

                    const getTestDescription = () => {
                      const isActive = isTestActive();
                      const displayTime = new Date(test?.test_date?.replace("Z", ""))?.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

                      if (isActive) {
                        return test?.description || "Test is now active - Click to attempt";
                      } else {
                        return test?.description || `Test starts at ${displayTime} - Not available yet`;
                      }
                    };

                    return (
                      <Grid item lg={4} md={6} sm={12} xs={12} key={index}>
                        <StudentTestCard
                          testtitle={test?.subject?.name}
                          testdesc={getTestDescription()}
                          duration={`${test?.duration || "duration"} mins`}
                          // testtime={formatTestTimeForDisplay(test?.test_date)}
                          testlink={isTestActive() ? `/student-test/${test?.id}` : null}
                          isActive={isTestActive()}
                        />
                      </Grid>
                    );
                  })
                ) : (
                  <div className={classes.noexamcont}>
                    <div className={classes.noexamimg}>
                      <img src={NoExamFound} alt="Not Found" />
                    </div>
                    <div>
                      <p className={classes.nocodeheader}>No Test Found</p>
                      <p className={classes.nocodesentence}>No has not uploaded any test for you to see.</p>
                    </div>
                  </div>
                )}
              </>
            )}
          </Grid>
          {/* <ToastContainer /> */}
          {/* <div className="pagination-container">
            <Pagination count={totalPages} page={currentPage} onChange={handlePageChange} variant="outlined" shape="rounded" color="primary" />
          </div> */}
        </div>
        {/* Exam Submitted MOdal */}
        <Modal
          title="Great Job"
          subtitle=""
          modalContent={
            <>
              <div>
                <div className={classes.forerrorimg}>
                  <img src={SubmittedImg} alt="Submitted Image" />
                </div>
                <div>
                  <p className={classes.nocodeheader}>Your Test has been submitted</p>
                  <p className={classes.nocodesentence}>Go to the result section to see your result</p>
                </div>
              </div>
            </>
          }
          modalFooter={
            <>
            </>
          }
          isopen={submittedModal}
          closeModal={handleSubmittedModal}
        />
        {/* No Exam Found MOdal */}
        <Modal
          title="Check For Your Exam"
          subtitle=""
          modalContent={
            <>
              <div>
                <div className={classes.noexamimg}>
                  <img src={NoExamFound} alt="Not Found" />
                </div>
                <div>
                  <p className={classes.nocodeheader}>No Test Found</p>
                  <p className={classes.nocodesentence}>The school admin has not uploaded any test for you to see.</p>
                </div>
              </div>
            </>
          }
          modalFooter={
            <>
            </>
          }
          isopen={noExamModal}
          closeModal={handleNoExamModal}
        />
      </div>
    }
    />
  );
};

export default StudentTest;
